import React, { useEffect, useMemo, useState } from 'react'
import { Column } from 'primereact/column'
import { FaRegTrashAlt } from 'react-icons/fa'
import {
  Btn,
  BtnIcon,
  CustomDataTable,
  CustomDropdown,
  InputNumeroDecimal,
  InputText,
  Loading,
  NumeroDecimal,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  deleteProdutoDePara,
  getProdutoDePara,
  getProdutos,
  saveProdutoDePara,
} from '../../../../services/api/https/registration/produto.http'
import { errorHandler } from '../../../../services/util/error.service'

export default function ModalProdutoDePara({ produto, empresas, active, onResponse }) {
  const [selectedEmpresa, setSelectedEmpresa] = useState(null)
  const [produtos, setProdutos] = useState([])
  const [selectedProduto, setSelectedProduto] = useState(null)
  const [convertFactor, setConvertFactor] = useState('')
  const [unidadePara, setUnidadePara] = useState('')
  const [associacoes, setAssociacoes] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const empresasDe = useMemo(
    () => empresas.filter(empresa => Number(empresa.id) !== Number(produto.company_id)),
    [empresas, produto.company_id],
  )
  const empresaPara = empresas.find(empresa => Number(empresa.id) === Number(produto.company_id))

  useEffect(() => {
    if (active && produto.id) loadAssociacoes()
  }, [active, produto.id])

  async function loadAssociacoes() {
    try {
      setIsLoading(true)
      const fetchedAssociacoes = await getProdutoDePara(produto.id)
      setAssociacoes(fetchedAssociacoes)
      clearForm()
    } catch (error) {
      onResponse('error', errorHandler(error))
    } finally {
      setIsLoading(false)
    }
  }

  function clearForm() {
    setSelectedEmpresa(null)
    setProdutos([])
    setSelectedProduto(null)
    setConvertFactor('')
    setUnidadePara('')
  }

  async function onEmpresaChange(empresa) {
    setSelectedEmpresa(empresa)
    setSelectedProduto(null)
    setProdutos([])

    if (!empresa) return

    try {
      setIsLoading(true)
      const response = await getProdutos(empresa.id)
      const fetchedProdutos = response.produtos || response
      setProdutos(
        fetchedProdutos.map(item => ({
          ...item,
          product_label: `${item.product_code} - ${item.name}`,
        })),
      )
    } catch (error) {
      onResponse('error', errorHandler(error))
    } finally {
      setIsLoading(false)
    }
  }

  async function onSave() {
    if (!selectedEmpresa) {
      onResponse('error', 'Selecione a Empresa DE')
      return
    }
    if (!selectedProduto) {
      onResponse('error', 'Selecione o Produto DE')
      return
    }
    if (convertFactor === '') {
      onResponse('error', 'Informe o Fator de Conversão')
      return
    }
    const numericConvertFactor = Number(convertFactor)
    if (!Number.isFinite(numericConvertFactor)) {
      onResponse('error', 'O Fator de Conversão deve ser numérico')
      return
    }
    if (numericConvertFactor < 0) {
      onResponse('error', 'O Fator de Conversão não pode ser negativo')
      return
    }
    if (!unidadePara.trim()) {
      onResponse('error', 'Informe a Unidade PARA')
      return
    }

    try {
      setIsLoading(true)
      const fetchedAssociacoes = await saveProdutoDePara(
        produto.id,
        selectedProduto.id,
        convertFactor,
        unidadePara,
      )
      setAssociacoes(fetchedAssociacoes)
      clearForm()
      onResponse('success', 'Correspondência de produtos cadastrada com sucesso')
    } catch (error) {
      onResponse('error', errorHandler(error))
    } finally {
      setIsLoading(false)
    }
  }

  async function onDelete(row) {
    try {
      setIsLoading(true)
      const fetchedAssociacoes = await deleteProdutoDePara(produto.id, row.id)
      setAssociacoes(fetchedAssociacoes)
      onResponse('success', 'Correspondência de produtos removida com sucesso')
    } catch (error) {
      onResponse('error', errorHandler(error))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="p-grid p-align-end" style={{ width: 980, minHeight: 440 }}>
      <div className="p-col-12">
        <span style={{ fontSize: '0.85rem' }}>
          Cadastre as correspondências de produtos entre diferentes Empresas. O Fator de Conversão
          será utilizado nos Ciclos de Entrega do tipo{' '}
          <strong>Recebimento - Estoque - DePara,</strong> convertendo a quantidade e produto da
          Empresa Origem (DE) para a quantidade e produto da Empresa Destino (PARA)
        </span>
      </div>

      <div className="p-col-12" style={{ paddingBottom: 0 }}>
        <strong>DE:</strong>
      </div>
      <div className="p-md-3 p-col-12">
        <CustomDropdown
          label="Empresa"
          optionLabel="name"
          filter
          options={empresasDe}
          value={selectedEmpresa}
          onChange={onEmpresaChange}
          placeholder="Selecione"
          disabled={isLoading}
        />
      </div>
      <div className="p-md-3 p-col-12">
        <CustomDropdown
          label="Produto"
          optionLabel="product_label"
          filter
          options={produtos}
          value={selectedProduto}
          onChange={setSelectedProduto}
          placeholder="Selecione"
          disabled={!selectedEmpresa || isLoading}
        />
      </div>
      <div className="p-md-2 p-col-12">
        <InputNumeroDecimal
          label="Fator de Conversão"
          marginTop={0}
          value={convertFactor}
          onChange={setConvertFactor}
          disabled={isLoading}
        />
      </div>
      <div className="p-md-2 p-col-12">
        <InputText
          label="Unidade"
          marginTop={0}
          value={unidadePara}
          onChange={value => setUnidadePara(value.toUpperCase())}
          inputStyle={{ textTransform: 'uppercase' }}
          disabled={isLoading}
        />
      </div>
      <div className="p-md-2 p-col-12" style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Btn style={{ marginBottom: 0 }} disabled={isLoading} onClick={onSave}>
          Salvar
        </Btn>
      </div>

      <div className="p-col-12" style={{ paddingBottom: 0 }}>
        <strong>PARA:</strong>
      </div>
      <div className="p-md-7 p-col-12">
        <strong>Produto:</strong> {produto.product_code} - {produto.name}
      </div>
      <div className="p-md-5 p-col-12">
        <strong>Empresa:</strong> {empresaPara ? empresaPara.name : ''}
      </div>

      <div className="p-col-12">
        {isLoading ? (
          <div className="text-center">
            <Loading size="md" />
          </div>
        ) : (
          <CustomDataTable
            value={associacoes}
            paginator
            rows={5}
            emptyMessage="Não existem correspondências cadastradas para este produto"
          >
            <Column field="company_name" header="Empresa" />
            <Column field="product_code" header="Código" />
            <Column field="product_name" header="Produto" />
            <Column field="unidade_para" header="Unidade" />
            <Column
              field="convert_factor"
              header="Fator de Conversão"
              body={row => <NumeroDecimal>{row.convert_factor}</NumeroDecimal>}
            />
            <Column
              header=""
              style={tableCellCentered(80)}
              body={row => (
                <BtnIcon onClick={() => onDelete(row)}>
                  <FaRegTrashAlt color="red" size={18} />
                </BtnIcon>
              )}
            />
          </CustomDataTable>
        )}
      </div>
    </div>
  )
}
